import dayjs, { Dayjs } from "utils/dayjs"

export interface IInvoiceByOrderNumberDto {
    orderNumber: string
    invoiceNumber?: string | null
    invoiceDate?: string | null
    createdOn?: string | null
}

export default class InvoiceByOrderNumberLookup {
    orderNumber: string
    invoiceNumber?: string
    invoiceDate?: Dayjs
    createdOn?: Dayjs

    constructor(dto: IInvoiceByOrderNumberDto) {
        this.orderNumber = dto.orderNumber
        this.invoiceNumber = dto.invoiceNumber ?? undefined
        this.invoiceDate = dto.invoiceDate ? dayjs(dto.invoiceDate) : undefined
        this.createdOn = dto.createdOn ? dayjs(dto.createdOn) : undefined
    }
}
